/**
 * Editorial V2 controlled-input guard.
 *
 * Shared dirty feedback must not synchronously re-render a MASTER parent from
 * input/change capture before the child has committed its first keystroke.
 * React 19 can still flush capture feedback before the controlled field when
 * it is queued as a microtask. Defer to the next task, after React's pending
 * input microtasks. Save or unmount invalidates stale feedback via the caller.
 */
export function scheduleEditorialDirtyAfterInput({ isCurrent, onDirty, enqueue = (callback) => setTimeout(callback, 0) }) {
  enqueue(() => {
    if (isCurrent()) onDirty();
  });
}
